export default "__VITE_ASSET__MuFxqo8K__"